import { api } from '@services';

const deleteEquipment = async (id: string): Promise<void> => {
  await api.delete<void>(`/equipments/${id}`);
};

export { deleteEquipment };
